export default __webpack_public_path__ + "static/media/office1-after1-768w.1e9e45f3.png";